import React from "react";
import { Link } from "react-router-dom";
import NavBarHome from "../NavBarHome";
// import RecentTable from "../recents/RecentTable";
import RecentLibrary from "../recents/RecentLibrary";
import "./Home.css";
import { useDropzone } from "react-dropzone";

function Home() {
  // Use Dropzone hook
  const { getRootProps, getInputProps, open } = useDropzone({
    // No click and no keyboard events to make whole page a dropzone without interfering with other interactions
    noClick: true,
    noKeyboard: true,
    onDrop: (acceptedFiles) => {
      console.log("Dropzone file accepted: ", acceptedFiles);
      // Handle file processing here
    },
    accept: {
      "application/pdf": [],
      "text/csv": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
      "application/json": [],
    },
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <NavBarHome title="Connectors" />
      <div className="cardPage">
        {/* <div className="pageTitle">
          <h3>Connections</h3>
        </div> */}
        <br />
        {/* <div className="pageHeader">
          <div className="headerLabel">FILE NAME</div>
          <div className="headerLabel">DATE</div>
        </div> */}

        <RecentLibrary showActions={true} onDataLoad={() => {}} type="library" />
      </div>
    </div>
  );
}

export default Home;
